import { Box, Grid } from "@material-ui/core";
import { memo, ReactNode } from "react";

import styles from "./Overlay.module.scss";

type OverlayProps = {
  readonly children: ReactNode;
};

export const Overlay = memo<OverlayProps>(({ children }) => (
  <Grid
    container
    justify="center"
    alignItems="center"
    className={styles.wrapper}
  >
    <Box className={styles.container}>{children}</Box>
  </Grid>
));
